export class TabModel {
 id: any;
 isActive: any ;
 description: any ;
 permissionMessage: any;
 htmlFlag: any;
 title: any;
}
